import { Base64Image, PersonDoc, UserForm } from 'common';
import { ConcourseDb } from '../ConcourseDb';
import { authInterceptor } from './AuthService';

export interface TeamDoc {
  _id?: string;
  _rev?: string;
  type: string;
  name: string;
  members: string[];
  deleted_date?: string;
  deleted_by?: string;
}

export class PeopleService {
  // This is jsut a 32x32 png of the concourse icon.
  static SYSTEM_ICON: string =
    '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';

  static getPeopleDb(projectId: string): ConcourseDb {
    return ConcourseDb.getInstance(`p-${projectId}-people`);
  }

  static async getPersonDocs(projectId: string): Promise<PersonDoc[]> {
    const db = this.getPeopleDb(projectId);
    db.syncRemote();
    return await db.getDocs();
  }
/*
  static async getPeople(
    projectId: string,
    onComplete: (docs: PersonDoc[]) => void,
    onChange: (docs: PersonDoc[]) => void,
    onError: (error: Error) => void = undefined,
  ): Promise<PersonDoc[]> {
    const db = this.getPeopleDb(projectId);

    if (onComplete) {
      db.on('complete', async (docs: PersonDoc[]) => {
        onComplete(docs);
      });
    }

    if (onChange) {
      db.on('change', (event: ChangeEvent) => {
        onChange(event.docs);
      });
    }

    if (onError) {
      db.on('error', onError);
    }
    return await db.getDocs();
  }*/

  static filterPeople(people: PersonDoc[], search: string): PersonDoc[] {
    if (!search || search.length == 0) return people;
    return people.filter(person => this.personMatches(person, search));
  }

  static findPerson(people: PersonDoc[], id: string): PersonDoc | undefined {
    if (id == 'system') {
      const image: Base64Image = {
        data: PeopleService.SYSTEM_ICON,
        mimeType: 'image/png',
        width: 64,
        height: 64,
      };
      return { _id: 'system', first_name: 'System', last_name: '', email: '', company: '', company_role: '', created_by: 'system', created_date: '2020-01-01 00:00', image };
    }
    return people.find(p => p._id == id);
  }

  static findPeopleByIds(people: PersonDoc[], ids: string[]): PersonDoc[] {
    return ids ? people.filter(p => ids.includes(p._id)) : [];
  }

  static personMatches(person: PersonDoc, search: string): boolean {
    return (
      person?.email?.toLowerCase().includes(search.toLowerCase()) ||
      (person.first_name && person.first_name.toLowerCase().includes(search.toLowerCase())) ||
      (person.last_name && person.last_name.toLowerCase().includes(search.toLowerCase())) ||
      (person.first_name && person.last_name && `${person.first_name} ${person.last_name}`.toLowerCase().includes(search.toLowerCase())) ||
      (person.company && person.company.toLowerCase().includes(search.toLowerCase())) ||
      (person.company_role && person.company_role.toLowerCase().includes(search.toLowerCase()))
    );
  }

  static async savePerson(projectId: string, doc: PersonDoc): Promise<PersonDoc> {
    const db = this.getPeopleDb(projectId);
    return await db.saveDoc(doc);
  }

  static findPersonByEmail(people: PersonDoc[], email: string): PersonDoc | undefined {
    return people.find(person => person.email === email);
  }

  static getPersonColor(person: PersonDoc): string {
    return person?.color ?? 'var(--ion-color-primary)';
  }

  static getGroupIcon(people: PersonDoc[]): string {
    if (people.length == 0) return '/assets/icon/question-mark.svg';
    if (people.length > 1) return '/assets/icon/group-icon.svg';
    return this.getIcon(people[0]);
  }
  static getIcon(person: PersonDoc): string {
    if (!person?.image?.data || !person?.image?.mimeType) {
      return person?.first_name?.charAt(0).toUpperCase() || '';
    }

    return `data:${person?.image?.mimeType};base64,${person?.image?.data}`;
  }

  static getGroupName(people: PersonDoc[]): string {
    return people.length == 1 ? this.getFullName(people[0]) : `${people.length} people`;
  }

  static getFullName(person: PersonDoc): string {
    return person ? `${person?.first_name} ${person?.last_name}` : 'Unknown';
  }

  static getInitials(person: PersonDoc): string {
    return person ? person?.first_name?.trim()?.charAt(0).toUpperCase() + person?.last_name?.trim()?.charAt(0).toUpperCase() : '';
  }

  static getFirstName(person: PersonDoc): string {
    return person ? person?.first_name : 'Unknown';
  }

  static getNameFromId(people: PersonDoc[], personId: string): string {
    const person = this.findPerson(people, personId);
    return person ? this.getFullName(person) : 'Unknown';
  }
  static getIconFromId(people: PersonDoc[], personId: string): string {
    const person = this.findPerson(people, personId);
    return person ? this.getIcon(person) : '/icons/person.svg';
  }

  /*******
   * In a strange decision, teams are stored in the same db as people.
   * This is laziness since there wont be many teams.... where else could we store them?
   */

  static searchTeams(teams: TeamDoc[], search: string): TeamDoc[] {
    if (!search || search.length == 0) return teams;
    return teams.filter(team => this.teamMatches(team, search));
  }
  static teamMatches(team: TeamDoc, search: string): boolean {
    return team.name.toLowerCase().includes(search.toLowerCase());
  }

  static async saveTeam(projectId: string, team: TeamDoc): Promise<TeamDoc> {
    return this.getPeopleDb(projectId).saveDoc(team);
  }

  static async inviteUser(userForm: UserForm, projectId: string, roles: string[], hash: string, date: string): Promise<{ message: string; person: PersonDoc }> {
    const url = globalThis.ccLambdaBaseUrl + '/fn/auth/invite-user';
    const response = await authInterceptor.POST(url, { userForm, projectId, roles, hash, date });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error('There was an error inviting the user: ' + errorData.message);
    }
    return await response.json();
  }

  static async removePersonFromProject(projectId: string, personId: string): Promise<void> {
    const url = globalThis.ccLambdaBaseUrl + '/fn/auth/remove-access';
    const response = await authInterceptor.POST(url, { projectId, personId });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(errorData.message);
    }

    const peopleDb = this.getPeopleDb(projectId);
    const docs = await peopleDb.getDocs();
    const teamsWithPerson = docs.filter(doc => doc?.type === 'team' && Array.isArray(doc.members) && doc.members.includes(personId)) as TeamDoc[];

    await Promise.all(
      teamsWithPerson.map(team => {
        const updatedTeam: TeamDoc = {
          ...team,
          members: team.members.filter(memberId => memberId !== personId),
        };
        return this.saveTeam(projectId, updatedTeam);
      }),
    );
  }
}
